import {css} from '@emotion/react'
import {LocalFile, RemoteFile} from './File.jsx'

const cssFileList = css({
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
})

const defualtFiles = []

export const FileList = ({
    after,
    before,
    files = defualtFiles,
    onChange,
    ...props
}) => {
    const onDeleteFile = onChange ?
        file => {
                const newFiles = files.filter(f => f !== file)
                onChange(newFiles)
        }
        :
        null

    const fileList = files.map(f => {
        if (f.src) {
            return (
                <RemoteFile
                    key={f.src}
                    file={f}
                    onDelete={onDeleteFile}
                />
            )
        }
        else {
            return (
                <LocalFile
                    key={`${f.name}${f.size}`}
                    file={f}
                    onDelete={onDeleteFile}
                />
            )
        }
    })

    return (
        <div
            css={cssFileList}
            {...props}
        >
            {before}
            {fileList}
            {after}
        </div>
    )
}
